import decorateComponentWithProps from 'decorate-component-with-props'
import Link from './Link'
import linkStrategy from './linkStrategy'

const linkPlugin = (config = {}) => {
  const {
    component,
    target = '_self'
  } = config

  return {
    decorators: [
      {
        strategy: linkStrategy,
        component: decorateComponentWithProps(Link, { target, component })
      }
    ]
  }
}

export default linkPlugin
